export
const name: string = "DefaultPrecision";

export
const preproc: string = ``;

export
const declaration: string = `
    #if GL_FRAGMENT_PRECISION_HIGH == 1
        precision highp float;
        precision highp int;
    #else
        precision mediump float;
        precision mediump int;
    #endif
`;

export
const varyings: string = ``;

export
const implementation: string = ``;
